'use strict';

(function () {
    angular.module('zp').constant('resultsGrid', {
        all: {
            limit: 768,
            vencanice: {
                lt: 4,
                gt: 6,
                useCarrier: false,
                class: 'col-md-4 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            },
            muzika: {
                lt: 4,
                gt: 4,
                useCarrier: false,
                class: 'col-md-6 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            },
            zlatare: {
                lt: 4,
                gt: 4,
                useCarrier: false,
                class: 'col-md-6 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            },
            torte: {
                lt: 4,
                gt: 6,
                useCarrier: false,
                class: 'col-md-4 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            },
            'dekoracija-cvece': {
                lt: 4,
                gt: 4,
                useCarrier: false,
                class: 'col-md-6 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            },
            general: {
                lt: 3,
                gt: 5,
                useCarrier: true,
                class: 'col-md-6 col-sm-6 col-xs-12',
                style: {
                    height: '300px'
                },
                recomended: []
            }
        }
    });
})();